import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import styled from 'styled-components'

export function SectionMain() {
	return (
		<Section>
			<ViewRoot>
				<ViewContent>
					<TextTitle>Отзывы заёмщиков и сберегателей о Credit.Club</TextTitle>
					<Text>
						Клиенты по всей стране решают свои задачи через нас: одни оформляют кредиты на выгодных
						условиях, другие — инвестируют деньги в «Сбережения» и получают достойную доходность.
						Посмотрите, что думают заёмщики и сберегатели о компании.
					</Text>
				</ViewContent>
				<Image name='KV' alt='' />
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	overflow: 'visible',
	marginTop: 24,
	backgroundColor: theme.colors.greenlight,
	borderRadius: 20,
	position: 'relative',
	marginBottom: 20,

	img: {
		display: 'none',
	},

	[theme.mediaQueries.mediaMinWidthTablet]: {
		img: {
			display: 'block',
		},
	},

	[theme.mediaQueries.mediaMinWidthMobile]: {
		borderRadius: 40,
	},
}))
const ViewContent = styled.div(({ theme }) => ({
	flex: 1,
	paddingTop: 20,
	paddingLeft: 20,
	paddingRight: 20,
	zIndex: 1,
	[theme.mediaQueries.mediaMinWidthTablet]: {
		paddingTop: 40,
		paddingLeft: 60,
		paddingRight: 0,
		maxWidth: '45%',
		marginRight: 'auto',
	},
}))

const TextTitle = styled.h1(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text18_24,
	marginBottom: 15,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text24_32,
		marginBottom: 30,
	},
}))
